import React, { useContext, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logofull from '../../../images/logo.png';
import clv from '../../../images/clv.png';

const NavHader = () => {
  
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );

  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        {toggle ?
          <img className="brand-clv" src={clv} alt="" />
          :
          <img className="brand-title" src={logofull} alt="" />
        }
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
